import React, { useState } from "react";
import Button from "components/CustomButton";
import Scrollbar from "react-scrollbars-custom";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import "assets/scss/partials/microsoftTeams.scss";
import TeamDashboard from "views/Teams/TeamDashboard/TeamDashboard";
import { ReactComponent as DashboardIcon } from "assets/img/icons/dashboard_2.svg";

export default () => {
  const [dialog, setDialog] = useState(false);
  const { setShowPollListTeams } = useTeamActionContext();

  const openTodoListDialog = () => {
    setDialog(true);
    setShowPollListTeams(true);
  };

  return (
    <>
      <Button
        buttonClass="invite-btn text-center microsoftTeamTodoListButton"
        onClick={openTodoListDialog}
      >
        <DashboardIcon style={{ fill: "white", width: "24px" }} />
        My Dashboard
      </Button>
      <Modal
        open={dialog}
        closeOnOverlayClick={false}
        onClose={() => setDialog(false)}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "microsoftTeamDashboard" }}
        closeOnEsc={false}
      >
        <div className="microsoftTeamsDialogHeader todoListMicrosoftTeamButton">
          {" "}
          Dashboard
          <div className="closeMicrosoftTeamsDialog">
            <CloseIcon onClick={() => setDialog(false)} className="cursor" />
          </div>
        </div>
        <div className="pollListContent">
          <Scrollbar style={{ height: "calc(100vh - 200px)" }}>
            <div>
              <div>
                <TeamDashboard onClose={() => setDialog(false)} />
              </div>
            </div>
          </Scrollbar>
        </div>
      </Modal>
    </>
  );
};
